import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getMenuById } from "../../api/MenuService";
import { getErrorMessage } from "../../utils/errorHandler";
export default function MenuView() {
  const location = useLocation();
  const params = useParams();
  const id = location.state?.menuId || params.id;
  const [menu, setMenu] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const fetchMenu = async () => {
    setLoading(true);
    try {
      setError("");
      const res = await getMenuById(id);
      setMenu(res?.data?.data || res?.data || res || null);
    } catch (error) {
      setError(getErrorMessage(error));
      setMenu(null);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) {
      fetchMenu();
    }
  }, [id]);
  if (loading) {
    return (
      <div className="text-center mt-2">
        <h6>Loading...</h6>
      </div>
    );
  }
  if (!menu) {
    return (
      <div className="text-center mt-2">
        <h6>{error || "Menu Not Found"}</h6>
      </div>
    );
  }
  return (
    <div
    >
      <div
        className="conatiner-fluid p-4"
       
      >
        <div className="card p-3">
          <h5 className="fw-bold mb-3">
            Menu Details - {menu.name}
          </h5>
          {/* ROW 1 */}
          <div className="row mb-2">
            <div className="col-4 px-1">
              <strong>Slug:</strong> {menu.slug || "-"}
            </div>
            <div className="col-4 px-1">
              <strong>Type:</strong> {menu.type || "-"}
            </div>
            <div className="col-4 px-1">
              <strong>Visible:</strong> {menu.visible ? "Yes" : "No"}
            </div>
          </div>
          {/* ROW 2 */}
          <div className="row">
            <div className="col-4 px-1">
              <strong>Order:</strong> {menu.order ?? "-"}
            </div>
            <div className="col-4 px-1">
              <strong>Parent:</strong>{" "}
              {menu.parentId?.name || menu.parentId?.title || menu.parentId?._id ||
                (typeof menu.parentId === "string" ? menu.parentId : "-")}
            </div>
            <div className="col-4 px-1">
              <strong>Status:</strong> {menu.status || "Inactive"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}